import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaperFullWidth: {
    maxWidth: '64.72vw',
  },
  rejectedItemsContainer: {
    flexGrow: 1,
    flexWrap: 'nowrap',
  },
  categoryContainer: {
    width: 'auto',
    flexFlow: 'nowrap',
  },
  rightPadding: {
    paddingRight: '1vw',
  },
  leftPadding: {
    paddingLeft: '1vw',
  },
  noOverflow: {
    display: '-webkit-box',
    overflow: 'hidden',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  category: {
    paddingBottom: '0.5vh',
    '@media (max-height: 576px)': {
      fontSize: rem(0.9),
    },
  },
  title: {
    display: 'flex',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    margin: '5vh auto 0 auto',
    color: theme.palette.primary.main,
    '@media (max-height: 576px)': {
      fontSize: rem(1.7),
      marginTop: '5vh',
    },
  },
  voidedItems: {
    height: '24.5vh',
    marginLeft: '5vw',
    marginRight: '6vw',
    '@media (aspect-ratio: 4/3)': {
      height: '24.7vh',
    },
  },
  arrows: {
    margin: 'auto',
    width: '20%',
  },
  itemList: {
    paddingBottom: '1.32vh',
  },
  messageLine: {
    paddingBottom: '0.5vh',
    textAlign: 'start',
    alignItems: 'flex-start',
    lineHeight: '1.56',
    color: themeColor.blackish,
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    marginTop: '3.78vh',
    '@media (max-height: 576px)': {
      fontSize: rem(0.9),
    },
  },
  icon: {
    display: 'flex',
    marginRight: 7,
    color: themeColor.alert,
  },
}));
